<template>
	<div class="subtotal-row">
		<added-to-cart
			:prebuild-price="getPrebuildPrice"
			:prebuild-cover-image="getPrebuildCoverImage"
			:prebuild-name="getPrebuildName"
		/>
		<slot />
	</div>
</template>

<script>
import addedToCart from "./added-to-cart";

export default {
	name: "SubtotalRow",
	components: {
		addedToCart
	},
	props: {
		prebuildDetails: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	computed: {
		getPrebuildName() {
			return this.prebuildDetails.name;
		},
		getPrebuildCoverImage() {
			return this.prebuildDetails.cover_image;
		},
		getPrebuildPrice() {
			return this.prebuildDetails.price;
		}
	}
};
</script>

<style lang="scss">


@media (min-width: 581px) and (max-width: 1199px) {
    .sub-total-row--top {
        flex-direction: row !important;

        .added-to-cart {
            .product-details {
                .product-title h1 {
                    margin-top: 0;
                }
            }
        }

        .sub-total {
            flex: .65;
            flex-direction: column;
            align-items: flex-end;

            &-details {
                margin: 0 0 10px 0;

            }

            &-action {
                width: 100%;
                .continue-to-cart {
                    width: 100%;
                    margin-left: 0;
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.subtotal-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dadde0;
    padding: 25px 0 43px 0;

    @media (max-width: 992px) {
        flex-direction: column;
    }

    .sub-total {
        @media (max-width: 768px) {
            flex-direction: column;
        }
    }
}
</style>
